interface BNObject {
  toString: () => string;
}

export interface SwapResult {
  inputAddress: BNObject;
  outputAddress: BNObject;
  inputAmount: string;
  outputAmount: string;
  txid: string;
}

export interface FormattedSwapResult {
  txid: string;
  inputAmount: string;
  outputAmount: string;
  inputAddress: string;
  outputAddress: string;
  rawInputAmount: string;
  rawOutputAmount: string;
}

// Helper function to get address from BN object
export function getAddressFromBN(bnObject: BNObject | undefined): string {
  if (!bnObject) return 'Unknown';
  return bnObject.toString();
}

export function formatSwapResult(swapResult: SwapResult): FormattedSwapResult | null {
  // Get addresses directly from BN objects using toString()
  const inputAddress = getAddressFromBN(swapResult?.inputAddress);
  const outputAddress = getAddressFromBN(swapResult?.outputAddress);

  if (!inputAddress || !outputAddress) {
    console.error('Missing addresses in swap result:', swapResult);
    return null;
  }

  return {
    txid: swapResult.txid,
    inputAmount: swapResult.inputAmount,
    outputAmount: swapResult.outputAmount,
    inputAddress,
    outputAddress,
    rawInputAmount: swapResult.inputAmount,
    rawOutputAmount: swapResult.outputAmount,
  };
}

export const INITIAL_SWAP_AMOUNT = (0.1 * 1e9).toString(); // 0.1 SOL in lamports
